"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function closestByClass(element, clazz) {
    var el = element;
    var b = false;
    while (!b) {
        el = el.parentNode;
        if (!el || !el.classList) {
            return null;
        }
        clazz.forEach(function (e) {
            if (el.classList.contains(e)) {
                b = true;
            }
        });
    }
    return el;
}
exports.closestByClass = closestByClass;
